/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schoolspecifictrainingfinishedat4Inputs */

const de__field_schoolspecifictrainingfinishedat4 = /** @type {(inputs: _Field_Schoolspecifictrainingfinishedat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schulspezifisches Einarbeitung`)
};

/**

* @param {_Field_Schoolspecifictrainingfinishedat4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schoolspecifictrainingfinishedat4 = /** @type {((inputs?: _Field_Schoolspecifictrainingfinishedat4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schoolspecifictrainingfinishedat4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_schoolspecifictrainingfinishedat4(inputs)
});
export { _field_schoolspecifictrainingfinishedat4 as "_field_schoolSpecificTrainingFinishedAt" }